export const VendorSelect_DialogBox_Id = 'vendorSelectDialogBoxId';
